import React from 'react';
import moment from 'moment';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import SlideForm from '../common/forms/SlideForm';
import CommonContext, { MomentDateFormat } from '../Common';
import { NumericInput } from '../common/forms/NumericInput';
import Input from '../common/forms/Input';

export default class MinimumWageRateForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            loading: true,
            errors: {},
            formValidated: false,
            validationMessage: '',
            isValidated: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    onClose = (response) => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    };

    onRemove = () => {
        this.context.setFormOpened(false);
        this.props.onRemoveCallback();
    };

    onSubmit = () => {
        this.context.setFormOpened(false);
        this.props.onSaveCallback();
    };

    populateState() {
        this.setState({
            loading: false,
        });
    }

    resetForm = () => this.setState({ formValidated: false, errors: {} });

    render() {
        const {
            entity, entityName, show, showRemove,
        } = this.props;

        if (!entity) {
            return '';
        }

        const {
            loading, formValidated, errors, validationMessage,
        } = this.state;

        const name = entityName ? `${entityName}.` : '';

        return (
            <SlideForm
                loading={loading}
                show={show}
                id="billingRateForm"
                formIcon={faMinusCircle}
                formTitle={
                    !!parseInt(entity.id ?? 0) > 0
                        ? 'Edit Min. Wage Rate'
                        : 'Add Min. Wage Rate'
                }
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={errors}
                onClearErrors={this.onClearErrors}
                error={validationMessage}
                showDelete={showRemove}
                onDelete={this.onRemove}
            >
                <>
                    <NumericInput
                        label="Rate"
                        formGroupClassName="ml-3 w-auto"
                        id={`${name}payRate`}
                        name={`${name}payRate`}
                        value={entity.payRate ?? {}}
                        onChange={this.props.onChange}
                        placeholder="Enter Rate"
                        step="0.01"
                        error="Min. Wage Rate is required."
                        required
                    />
                    <Input
                        label="Effective Date"
                        formGroupClassName="ml-3 w-auto"
                        id={`${name}startDate`}
                        name={`${name}startDate`}
                        onChange={this.props.onChange}
                        value={
                            moment(entity.startDate).format(
                                MomentDateFormat.DateOnlyUTCHyphenated,
                            ) ?? ''
                        }
                        type="date"
                        error="Effective Date is required."
                        required
                    />
                    <Input
                        label="Expiration Date"
                        formGroupClassName="ml-3 w-auto"
                        id={`${name}endDate`}
                        name={`${name}endDate`}
                        value={
                            moment(entity.endDate).format(
                                MomentDateFormat.DateOnlyUTCHyphenated,
                            ) ?? ''
                        }
                        onChange={this.props.onChange}
                        type="date"
                    />
                </>
            </SlideForm>
        );
    }
}
